import img from "../sc-01.png";

export default {
  title: "Runn",
  content: `
🏃‍♂️Run (side-scrolling game) + 🤖RNN . The player has to play the game generated by the RNN model. I’m exploring the idea of using gamification to make the musical machine learning algorithms more understandable and fun.
  `,
  links: [
    {
      name: "play it here",
      url: "https://vibertthio.com/runn"
    },
    {
      name: "Source Code",
      url: "https://github.com/vibertthio/runn"
    }
  ],
  img
};



// WEBPACK FOOTER //
// ./src/pages/projects/runn/desc/index.js